// The ONE distance formatter (#156): metres under 1000, kilometres from there.
// Distance has no Profile unit preference yet (only weight and glucose do), so
// the unit is metric until one exists; when it does, it lands here and nowhere
// else. Pure, locale-aware decimal separator.
export function formatDistance(meters: number, locale: string): string {
  if (meters < 1000) {
    const m = new Intl.NumberFormat(locale, { maximumFractionDigits: 0 }).format(meters);
    return `${m} m`;
  }
  const km = new Intl.NumberFormat(locale, { maximumFractionDigits: 2 }).format(meters / 1000);
  return `${km} km`;
}
